import { Link, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";
import { homeFor, useAuth } from "@/context/AuthContext";
import { ui } from "@/lib/ui";

export default function CustomerLogin() {
  const { user } = useAuth();
  if (user) return <Navigate to={homeFor(user)} replace />;

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/portal";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthShell
      eyebrow="customer access"
      title="Sign in"
      subtitle="Request a tow, see your price upfront and track your past jobs."
      footer={<Link to="/staff/login" className="font-mono text-xs uppercase tracking-wider text-slate-500 hover:text-cyan-300" data-testid="staff-login-button">Staff / dispatcher login →</Link>}
    >
      <Button onClick={signIn} className={`${ui.btnPrimary} w-full h-12`} data-testid="customer-google-login-button">
        Continue with Google
      </Button>
      <p className="mt-4 text-xs text-slate-500">New here? Signing in creates your customer account automatically.</p>
    </AuthShell>
  );
}
